import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookA, Star, SpellCheck2, Volume2, Printer } from "lucide-react";
import { http } from "@/lib/api";
import { speak } from "@/lib/buddy";

export const WordStars = ({ w }) => (
  <span className="inline-flex items-center gap-1">
    {w.mastered && <Star className="w-4 h-4 text-[#D99B26] fill-current" aria-label="Knows the meaning" data-testid={`word-star-${w.id}`} />}
    {w.spell_mastered && <SpellCheck2 className="w-4 h-4 text-[#6B9080]" aria-label="Can spell it" data-testid={`word-spell-star-${w.id}`} />}
  </span>
);

export const KidWords = ({ kid }) => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get(`/students/${kid.id}/words`).then((r) => setD(r.data)).catch(() => {}); }, [kid.id]);
  if (!d) return null;
  return (
    <details className="mt-4 rounded-2xl bg-[#F7F3EB] p-4" data-testid={`parent-words-${kid.id}`}>
      <summary className="text-sm cursor-pointer text-[#2C4A3E] inline-flex items-center gap-1.5 w-full">
        <BookA className="w-4 h-4" /> Word Bank: {d.total} words · <Star className="w-3.5 h-3.5 text-[#D99B26] fill-current" /> {d.mastered} meanings · <SpellCheck2 className="w-3.5 h-3.5 text-[#6B9080]" /> {d.spelled} spelled
      </summary>
      {d.total === 0 ? <p className="text-sm text-stone-500 mt-3">No saved words yet. Words appear here when {kid.name.split(" ")[0]} long-presses a word while reading.</p> : (
        <>
          <ul className="mt-3 space-y-2 max-h-72 overflow-y-auto">
            {d.words.map((w) => (
              <li key={w.id} className="flex items-start gap-3 rounded-xl bg-white px-3 py-2" data-testid={`parent-word-${w.id}`}>
                <button onClick={() => speak(`${w.word}. ${w.meaning}`, "nova", 0.85).catch(() => {})} aria-label={`Hear ${w.word}`} data-testid={`parent-word-say-${w.id}`} className="p-1.5 rounded-full bg-[#F1EADB] mt-0.5"><Volume2 className="w-3.5 h-3.5" /></button>
                <div className="flex-1 text-sm"><b className="text-[#2C4A3E]">{w.word}</b> <WordStars w={w} /><p className="text-stone-600">{w.meaning}</p></div>
              </li>
            ))}
          </ul>
          <Link to={`/practice/${kid.id}`} data-testid={`parent-practice-${kid.id}`} className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#2C4A3E] text-white text-sm"><Printer className="w-4 h-4" /> Practice together (printable)</Link>
        </>
      )}
    </details>
  );
};
